/* eslint-disable */

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Account": [
      "Org",
      "User"
    ],
    "AccountInterface": [
      "Org",
      "User"
    ],
    "ActivityBody": [
      "AgentThreadActivity",
      "CommentActivity",
      "StatusUpdateActivity"
    ],
    "Assignable": [
      "DocumentVariable",
      "SignatureField",
      "WorkflowPermission"
    ],
    "Commentable": [
      "Document",
      "Task",
      "Workflow"
    ],
    "DocLocation": [
      "AlineLocation",
      "FileLocation"
    ],
    "DocumentMentionAccessResult": [
      "Document",
      "MentionAccessError"
    ],
    "Field": [
      "DocumentVariable",
      "SignatureField"
    ],
    "FileVersion": [
      "DocumentVersion",
      "StaticFileVersion"
    ],
    "FileVersionInterface": [
      "DocumentVersion",
      "StaticFileVersion"
    ],
    "MentionEntitySearchResult": [
      "Document",
      "Playbook",
      "Report",
      "User",
      "Workflow"
    ],
    "Phase": [
      "NonSigningPhase",
      "SigningPhase"
    ],
    "PlaybookMentionAccessResult": [
      "MentionAccessError",
      "Playbook"
    ],
    "ReportColumnOption": [
      "ExtractionReportColumn",
      "FileFieldColumn"
    ],
    "ReportMentionAccessResult": [
      "MentionAccessError",
      "Report"
    ],
    "ReportRow": [
      "DocumentRow",
      "GroupHeaderRow",
      "OrphanRelationshipRow",
      "UrlRelationshipRow"
    ],
    "SkillVersionMentionAccessResult": [
      "AgentSkillVersion",
      "MentionAccessError"
    ],
    "Storable": [
      "Document"
    ],
    "StorableInterface": [
      "Document"
    ],
    "StreamAgentPayload": [
      "ArtifactCreatedEvent",
      "AssistantMessageEvent",
      "LoadingEvent",
      "PlanSnapshotEvent",
      "ReportArtifactCreatedEvent",
      "SkillArtifactCreatedEvent",
      "TitleUpdateEvent",
      "ToolStatusUpdateEvent",
      "WorkflowArtifactCreatedEvent"
    ],
    "TaskMentionAccessResult": [
      "MentionAccessError",
      "Task"
    ],
    "ThreadArtifact": [
      "ThreadDocumentArtifact",
      "ThreadReportArtifact",
      "ThreadSkillArtifact",
      "ThreadTaskArtifact",
      "ThreadWorkflowArtifact"
    ],
    "WorkflowAction": [
      "Task",
      "WorkflowRecipient"
    ],
    "WorkflowMentionAccessResult": [
      "MentionAccessError",
      "Workflow"
    ],
    "WorkflowPhasesChangedEvent": [
      "WorkflowIntakeFormAddedEvent",
      "WorkflowIntakeFormRemovedEvent",
      "WorkflowIntakeFormUpdatedEvent",
      "WorkflowPhaseCreatedEvent",
      "WorkflowPhaseDeletedEvent",
      "WorkflowPhaseUpdatedEvent",
      "WorkflowPhasesReorderedEvent"
    ],
    "WorkflowPhasesChangedPayload": [
      "WorkflowIntakeFormAddedEvent",
      "WorkflowIntakeFormRemovedEvent",
      "WorkflowIntakeFormUpdatedEvent",
      "WorkflowPhaseCreatedEvent",
      "WorkflowPhaseDeletedEvent",
      "WorkflowPhaseUpdatedEvent",
      "WorkflowPhasesReorderedEvent"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Account": [
      "Org",
      "User"
    ],
    "AccountInterface": [
      "Org",
      "User"
    ],
    "ActivityBody": [
      "AgentThreadActivity",
      "CommentActivity",
      "StatusUpdateActivity"
    ],
    "Assignable": [
      "DocumentVariable",
      "SignatureField",
      "WorkflowPermission"
    ],
    "Commentable": [
      "Document",
      "Task",
      "Workflow"
    ],
    "DocLocation": [
      "AlineLocation",
      "FileLocation"
    ],
    "DocumentMentionAccessResult": [
      "Document",
      "MentionAccessError"
    ],
    "Field": [
      "DocumentVariable",
      "SignatureField"
    ],
    "FileVersion": [
      "DocumentVersion",
      "StaticFileVersion"
    ],
    "FileVersionInterface": [
      "DocumentVersion",
      "StaticFileVersion"
    ],
    "MentionEntitySearchResult": [
      "Document",
      "Playbook",
      "Report",
      "User",
      "Workflow"
    ],
    "Phase": [
      "NonSigningPhase",
      "SigningPhase"
    ],
    "PlaybookMentionAccessResult": [
      "MentionAccessError",
      "Playbook"
    ],
    "ReportColumnOption": [
      "ExtractionReportColumn",
      "FileFieldColumn"
    ],
    "ReportMentionAccessResult": [
      "MentionAccessError",
      "Report"
    ],
    "ReportRow": [
      "DocumentRow",
      "GroupHeaderRow",
      "OrphanRelationshipRow",
      "UrlRelationshipRow"
    ],
    "SkillVersionMentionAccessResult": [
      "AgentSkillVersion",
      "MentionAccessError"
    ],
    "Storable": [
      "Document"
    ],
    "StorableInterface": [
      "Document"
    ],
    "StreamAgentPayload": [
      "ArtifactCreatedEvent",
      "AssistantMessageEvent",
      "LoadingEvent",
      "PlanSnapshotEvent",
      "ReportArtifactCreatedEvent",
      "SkillArtifactCreatedEvent",
      "TitleUpdateEvent",
      "ToolStatusUpdateEvent",
      "WorkflowArtifactCreatedEvent"
    ],
    "TaskMentionAccessResult": [
      "MentionAccessError",
      "Task"
    ],
    "ThreadArtifact": [
      "ThreadDocumentArtifact",
      "ThreadReportArtifact",
      "ThreadSkillArtifact",
      "ThreadTaskArtifact",
      "ThreadWorkflowArtifact"
    ],
    "WorkflowAction": [
      "Task",
      "WorkflowRecipient"
    ],
    "WorkflowMentionAccessResult": [
      "MentionAccessError",
      "Workflow"
    ],
    "WorkflowPhasesChangedEvent": [
      "WorkflowIntakeFormAddedEvent",
      "WorkflowIntakeFormRemovedEvent",
      "WorkflowIntakeFormUpdatedEvent",
      "WorkflowPhaseCreatedEvent",
      "WorkflowPhaseDeletedEvent",
      "WorkflowPhaseUpdatedEvent",
      "WorkflowPhasesReorderedEvent"
    ],
    "WorkflowPhasesChangedPayload": [
      "WorkflowIntakeFormAddedEvent",
      "WorkflowIntakeFormRemovedEvent",
      "WorkflowIntakeFormUpdatedEvent",
      "WorkflowPhaseCreatedEvent",
      "WorkflowPhaseDeletedEvent",
      "WorkflowPhaseUpdatedEvent",
      "WorkflowPhasesReorderedEvent"
    ]
  }
};
      export default result;
    